import React from "react";
import { useRecoilState } from "recoil";
import { regularDriverState } from "../../state/QuoteState";
import SummaryItem from "../../components/SummaryItem";
import CustomDivider from "../../components/CustomDivider";

const RegularDriverSummary = ({ onEdit }: { onEdit: () => void }) => {
  const [
    {
      day,
      email,
      employmentStatus,
      gender,
      idNumber,
      idType,
      maritalStatus,
      mobilePhoneNumber,
      month,
      name,
      surname,
      title,
      year,
      policyHolderIsDriver,
      relationshipToPolicyHolder,
    },
  ] = useRecoilState(regularDriverState);

  return (
    <>
      {policyHolderIsDriver ? (
        <SummaryItem items={[relationshipToPolicyHolder]} onEdit={onEdit}>
          Regular driver is policy holder
        </SummaryItem>
      ) : (
        <>
          <SummaryItem items={[relationshipToPolicyHolder]} onEdit={onEdit}>
            Relationship to the policy holder
          </SummaryItem>
          <CustomDivider />
          <SummaryItem items={[idNumber, idType]} onEdit={onEdit}>
            Regular driver ID
          </SummaryItem>
          <CustomDivider />
          <SummaryItem items={[title, name, surname]} onEdit={onEdit}>
            Regular driver name
          </SummaryItem>
          <CustomDivider />
          <SummaryItem items={[`${day}-${month}-${year}`]} onEdit={onEdit}>
            Date of birth
          </SummaryItem>
          <CustomDivider />
          <SummaryItem
            items={[gender, maritalStatus, employmentStatus]}
            onEdit={onEdit}
          >
            Further information
          </SummaryItem>
          <CustomDivider />
          <SummaryItem items={[mobilePhoneNumber, email]} onEdit={onEdit}>
            Contact data
          </SummaryItem>
        </>
      )}
    </>
  );
};

export default RegularDriverSummary;
